import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrTN: CultureInfo = {
  name: 'fr-TN',
  displayName: 'français (Tunisie)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-TN',
  parent: CultureInfoFr
};
